import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { HashRouter } from 'react-router-dom';
import App from './App';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import {IntlProvider} from "react-intl";
import ErrorBoundary from "./components/error/ErrorBoundary";
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import {getDirection, getLocale, getMessages} from "./handler/LocaleHandler";
import GlobalStateContextProvider from "./components/global/context/GlobalStateContext";
import PermissionsContextProvider from "./components/permissions/PermissionContext";

addLocaleData(en);
addLocaleData(ja);
addLocaleData(it);
addLocaleData(fr);
addLocaleData(es);

getLocale().then(locale => {
    document.getElementsByTagName(`html`)[0].setAttribute("dir", getDirection(locale));
    ReactDOM.render((
        <IntlProvider locale={locale} messages={getMessages(locale)}>
            <GlobalStateContextProvider>
                <ErrorBoundary>
                    <PermissionsContextProvider>
                        <HashRouter>
                            <App/>
                        </HashRouter>
                    </PermissionsContextProvider>
                </ErrorBoundary>
            </GlobalStateContextProvider>
        </IntlProvider>
    ), document.getElementById('root'));
})



// WEBPACK FOOTER //
// ./src/index.js